import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthState } from '@x/ecommerce-shop/app/core/auth/state/auth.state';
import { IShopAuthUser } from '@x/ecommerce/shop-client';

export const myAccountUserResolver: ResolveFn<IShopAuthUser | null> = (
  route: ActivatedRouteSnapshot,
) => {
  const store = inject(Store);
  return store.selectOnce(AuthState.loggedInUser);
};
